/* eslint-disable no-var, prefer-template, prefer-arrow-callback */
/**
 * COMPONENT EMAIL Out of stock
 *
 * This is used in various places in the site to control the  EMAIL Out of stock controls
 * It has to be flexible aware of its surrounding to choose the correct functionality.
 * //todo discuss whether this code can be refactored and made more clean
 */
require('./jquery.validate')(jQuery);

var gridView = null;
var submitCount = 0;

/**
 * Sets up interaction for the form including error feedback and event handlers
 * @param form jquery selector for the form
 */
function formBind(form) {
  var isPLP = $('.resultList').length > 0;
  var isPLPGrid = $('.resultGrid').length > 0;
  var isCompare = false;
  var isRecommended = false;
  var row = null;
  var inputs = form.find('input');
  var fieldset = form.find('fieldset');
  var feedback = null;
  var formType = $(form).attr('data-type');
  var emailWhenBackButton = null;
  var viewSimilarInfo = $('.border-t.prd-alt');
  var submitButton = form.find('[type="submit"]');
  var toggleLink;
  var closeBtn;
  var oosLinkHrefAttribute = '"#email-when-back-' + formType + '"';

  // Initial state
  form.addClass('form-hide');

  function enableFormSubmit() {
    submitButton.removeAttr('disabled');
    form.removeClass('form-error');
  }

  function disableFormSubmit() {
    submitButton.attr('disabled', 'disabled');
    form.addClass('form-error');
  }

  // Init dynamical hide/show of form labels
  inputs.each(function hideOrShowFormLabels() {
    var input = $(this);
    var label = form.find('label[for=' + input[0].id + '].label-helper');

    input.focus(function onFocus() {
      if (!input.hasClass('error') && input[0].value !== '') {
        label.addClass('show-label');
      } else {
        label.removeClass('show-label');
      }
      $(this).parent().addClass('hide-validation-error');
    });

    input.keyup(function onKeyUp() {

      if (input.hasClass('error')) {
        label.removeClass('show-label');
        return false;
      }
      if (input[0].value) {
        label.addClass('show-label');
      } else {
        label.removeClass('show-label');
        input.removeClass('valid');
      }
      return true;
    });

    input.blur(function onBlur() {
      var validator = form.validate();
      label.removeClass('show-label');
      if (validator.checkForm()) {
        enableFormSubmit();
      }
      $(this).parent().removeClass('hide-validation-error');
    });

  });

  // Toggle links
  // type: 'touch' / 'desktop'
  toggleLink = $(
    '[href=' + oosLinkHrefAttribute + '].email-when-back,' + // for <a>
    '[data-href=' + oosLinkHrefAttribute + '].email-when-back' // for <span>
  );

  toggleLink.bind('click', function onClick(e) {
    var self = $(this);
    var fupid = form.find('input[name="sFUPID"]');
    var scrollTo;
    var prd;
    var container;
    var lastProductInRow;
    var offsetPage;
    var offsetWindow;
    var allInputsEmpty;
    submitCount = 0;

    e.preventDefault();
    e.stopPropagation();

    isCompare = self.parents('.compareTable').length;
    isRecommended = self.parents('#recommended-products').length;

    fieldset.show();
    if (feedback) {
      $(feedback).remove();
    }

    form.addClass('form-show');

    if (isPLP) {
      prd = self.parents('.product');
      // Set value of input for the related product
      fupid.val(self.attr('data-fupid'));
      form.insertAfter(prd);
      scrollTo = form.offset().top - $('div[data-component="compare-panel"]').outerHeight();

    } else if (isCompare) {
      row = $('tr.oos-form-container').addClass('oos-form-container-display');
      row.addClass('oos-form-container-display');

      // MCD-469:
      $('#compareTableHeader').addClass('hidden'); // hide floating header when form opens

      fupid.val(self.attr('data-fupid'));
      scrollTo = form.offset().top;

    } else if (isRecommended) {
      container = self.parents('#recommended-products');
      fupid.val(self.attr('data-fupid'));
      form.insertAfter(container);
      scrollTo = form.offset().top;

    } else if (isPLPGrid) {
      gridView.hideVisibleDesc();
      lastProductInRow = gridView.getLastInRow(self.closest('.product'));
      fupid.val(self.attr('data-fupid'));
      form.insertAfter(lastProductInRow);
      scrollTo = form.offset().top - $('div[data-component="compare-panel"]').outerHeight();

    } else { // product page
      viewSimilarInfo.hide();

      if ($('#rr_placement_1').length > 0) {
        offsetPage = $('#rr_placement_1').offset().top; // offset gathered from Rich Relevance
      } else {
        offsetPage = $('#footer').offset().top; // offset gathered from footer when rich relevance not on the page
      }

      offsetWindow = offsetPage - $(window).scrollTop();

      if (form.outerHeight() > offsetWindow) {
        scrollTo = offsetPage - form.outerHeight();

      } else {
        scrollTo = form.offset().top;
        scrollTo -= $('#toolbar').outerHeight();
      }
    }

    form.addClass('form-show');

    // this if branch is not necessary on listing page
    if (!isPLP && !isPLPGrid) {
      if (emailWhenBackButton !== null) {
        emailWhenBackButton.closest('.prd-channels').removeClass('hidden');
      }
      emailWhenBackButton = $(this);
      emailWhenBackButton.closest('.prd-channels').addClass('hidden');
    } else {
      // shows all 'email me when back' buttons on listing page
      $('span.email-when-back[data-fupid]')
        .closest('.prd-channels').removeClass('hidden');
      // hide clicked 'email me when back' buttons on listing page
      $(this).closest('.prd-channels').addClass('hidden');
    }

    // the email-when-back-touch-closed-bottom buttons
    // needs to know how to close the email link at the top
    // http://jira.dixons.co.uk/browse/MCD-935
    // this code is not necessary on listing page
    if (!isPLP && !isPLPGrid) {
      if (e.target.id === 'email-when-back-touch-closed-bottom' ||
        e.target.parentElement.id === 'email-when-back-touch-closed-bottom') {
        $('#email-when-back-touch-closed').closest('.prd-channels').addClass('hidden');
      }
    }

    allInputsEmpty = true;
    form.find('input[type="text"], input[type="email"]').each(function checkEmptyValues() {
      if ($(this).val() !== '') {
        allInputsEmpty = false;
      }
    });

    if (allInputsEmpty) {
      disableFormSubmit();
    }

    $('html, body').stop().animate({ scrollTop: scrollTo });
  });

  // Automatic form open when #email-when-back fragment is present in URL.
  if (window.location.hash.indexOf('#email-when-back') !== -1) {
    toggleLink.click();
  }

  closeBtn = form.find('a.close');

  /**
   * We bind click listeners to the close buttons
   * and then check for the nearest elements to show to the user while hiding the form
   */
  closeBtn.click(function onClick(e) {
    var tableRow;
    var productActions;
    e.preventDefault();

    /**
     * Becasue this code is written as to expect buttons to not talk to each other
     * we need this check here: http://jira.dixons.co.uk/browse/MCD-935
     * This if branch is not used on listing page
     */
    if (!isPLP && !isPLPGrid) {
      if (emailWhenBackButton[0].id === 'email-when-back-touch-closed-bottom') {
        $('#email-when-back-touch-closed').closest('.prd-channels').removeClass('hidden');
      } else {
        emailWhenBackButton.closest('.prd-channels').removeClass('hidden');
      }
    } else {
      // shows all email-me-when-back buttons on listing page
      $('span.email-when-back[data-fupid]')
        .closest('.prd-channels').removeClass('hidden');
    }

    viewSimilarInfo.show();
    form.removeClass('form-show');
    if (isCompare) {
      tableRow = form.parent('tr');
      if (typeof tableRow !== 'undefined') {
        tableRow.removeClass('oos-form-container-display');
      }

      $('#compareTableHeader').removeClass('hidden'); // restore floating header
    }

    productActions = $('#product-actions');
    if (productActions.length > 0) {
      $(window).trigger('resize');
    }
  });

  $(form).on('input', function onInput() {
    var validator = form.validate();

    // check if forms is valid
    if (validator.checkForm()) {
      form.valid(); // check again with add css classes for success (green borders)
      enableFormSubmit();
    }
  });

  // Validation
  form.validate({
    errorPlacement: function errorPlacement(error, elt) {
      error.prependTo(elt.parent('p'));
    },

    submitHandler: function submitHandler() {
      submitCount += 1;
      if (submitCount === 1) {
        submitForm();
      }
    },

    onkeyup: function onkeyup(element, event) {
      var validator = form.validate();

      // 9 == tab key
      if (event.which !== 9 || this.elementValue(element) !== '') {
        if (this.element(element) === false) {
          $('label.label-helper').removeClass('show-label');
          if (!form.hasClass('form-error')) {
            return disableFormSubmit();
          }
        } else if (validator.checkForm()) {
          enableFormSubmit();
        } else {
          disableFormSubmit();
        }
      }
      return false;
    },

    rules: {
      first_name: {
        lettersonly: true
      },
      last_name: {
        lettersonly: true
      },
      email: {
        required: true,
        email: true,
        validemail: true
      }
    },

    invalidHandler: function invalidHandler(event, validator) {
      var errors = validator.numberOfInvalids();
      if (errors) {
        disableFormSubmit();
      } else {
        enableFormSubmit();
      }
    }
  });

  /**
   * Submits the form if the submit button it not disabled
   * todo where is form coming from here, its not passed in?
   */
  function submitForm() {
    var url = form.attr('action');
    var method = form.attr('method');

    // check if the submit button is enabled, do nothing if it isn't
    if (submitButton.attr('disabled') === true || submitButton.attr('disabled') === 'disabled') {
      return false;
    }

    // disable the button until the ajax request finishes,
    // so it's not possible to send multiple request with double-click
    submitButton.attr('disabled', true);
    $.ajax({
      url: url,
      method: method,
      data: form.serialize(),
      success: function onSuccess(res) {
        var similarPrd;
        submitButton.attr('disabled', false);

        if (res.result !== 'OK') {
          return false;
        }

        fieldset.hide();
        feedback = document.createElement('DIV');
        feedback.innerHTML = res.content;
        $(feedback).insertAfter(fieldset);

        // If we are in product page and 1 recommended product exist, display it
        if (!isCompare && !isPLP) {
          similarPrd = $('#' + form.attr('data-similar'));
          if (similarPrd.length) {
            similarPrd.addClass('recommended-product-display');
          }
        }
        return true;
      },
      error: function onError() {
        submitButton.attr('disabled', false);
        return false;
      }
    });

    return true;
  }
}

/**
 * Set up these selectors with the prefillForms and then
 * @param {string} selector this is used with the classes email-when-back-form
 * @param {element} productsViewGrid The grid view module
 */
function initFormSubmit(selector, productsViewGrid) {
  var forms;

  // init of validators
  $.validator.addMethod('lettersonly', function lettersOnlyValidation(value, element) {
    return this.optional(element) || /^[a-zA-Z\u00C0-\u017F'’ -]+$/i.test(value);
  }, 'Enter letters only please.');
  $.validator.addMethod('validemail', function emailValidation(value, element) {
    return this.optional(element) ||
      /^[a-zA-Z0-9]+[a-zA-Z0-9_.+-]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]+[a-zA-Z0-9-.]+$/i.test(value);
  }, 'Please enter a valid email address.');

  if (productsViewGrid) {
    gridView = productsViewGrid;
  }

  forms = $(selector);
  forms.each(function processForm() {
    var form = $(this);
    formBind(form);
  });
}

/**
 * Shows or hides 'email me when product back' form on listing page
 * for specified product
 *
 * @param fupid fupid of the specified product on listing page
 */
function showOrHideEmailMeBackFormForProduct(fupid) {
  var form = $('.email-when-back-form');
  var fupidInput = form.find('input[name="sFUPID"]');
  var isPLP = $('.resultList').length;
  var isPLPGrid = $('.resultGrid').length;
  var prd;
  var scrollTo;
  var lastProductInRow;
  var allInputsEmpty;

  // form is opened for product with fupid so only scrolling is performed
  if (form.hasClass('form-show') && String(fupid) === String(fupidInput.val())) {
    scrollTo = form.offset().top - $('div[data-component="compare-panel"]').outerHeight();
    $('html, body').stop().animate({ scrollTop: scrollTo });
    return;
  }

  // shows all 'email me when back' buttons on listing page
  $('span.email-when-back[data-fupid]')
    .closest('.prd-channels').removeClass('hidden');

  // hides form
  form.removeClass('form-show');

  // hides button for product on listing page
  $('span.email-when-back[data-fupid="' + fupid + '"]')
    .closest('.prd-channels').addClass('hidden');

  submitCount = 0;

  form.find('fieldset').show();
  form.find('div.oos-email-confirmation').closest('div').remove();

  form.addClass('form-show');

  if (isPLP) {
    prd = $('article#product' + fupid);
    form.insertAfter(prd);
  }

  if (isPLPGrid) {
    gridView.hideVisibleDesc();
    lastProductInRow = gridView.getLastInRow($('article#product' + fupid));
    form.insertAfter(lastProductInRow);
  }

  fupidInput.val(fupid);
  scrollTo = form.offset().top - $('div[data-component="compare-panel"]').outerHeight();

  allInputsEmpty = true;
  form.find('input[type="text"], input[type="email"]').each(function checkEmptyValues() {
    if ($(this).val() !== '') {
      allInputsEmpty = false;
    }
  });

  if (allInputsEmpty) {
    form.find('[type="submit"]').attr('disabled', 'disabled');
    form.addClass('form-error');
  }

  $('html, body').stop().animate({ scrollTop: scrollTo });
}

module.exports = {
  initFormSubmit: initFormSubmit,
  showOrHideEmailMeBackFormForProduct: showOrHideEmailMeBackFormForProduct
};
